import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Login')
  },
  {
    path: '/sim',
    name: 'SimApiDemo',
    component: () => import('@/views/SimApiDemo')
  },
  {
    path: '/story',
    name: 'DemoGameStory',
    component: () => import('@/views/DemoGameStory')
  },
  {
    path: '/empty',
    name: 'DemoGameEmpty',
    component: () => import('@/views/DemoGameEmpty')
  },
  {
    path: '/mind524',
    name: 'DemoMind524',
    component: () => import('@/views/DemoMind524')
  },
  {
    path: '/mind524/end',
    name: 'ReponsePage',
    component: () => import('@/views/ReponsePage')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
